
import React, { useState } from 'react';
import { Box, Grid, Typography, TextField, Button, Switch, FormControlLabel, Link } from '@mui/material';
import { Email, Phone, Person } from '@mui/icons-material';
import colors from '../../../../../colors'
import IncludedCountries from './IncludedCountries';
import PublicIcon from '@mui/icons-material/Public';
import { texts } from '../../../../../general/texts';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { selectGlobalDataState } from '../../../../../../features/global/globalDataSlice';
import { useDispatch, useSelector } from 'react-redux';
import { sendGeneralRequest } from '../../../../../../features/generalRequest';
import SingleExpandedInvoice from '../../SingleExpandedInvoice';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { useNavigate } from 'react-router-dom';

const AddUserData = (props) => {

    const [isDialogOpened, setIsDialogOpened] = useState(false)
    const isSmallScreen = useMediaQuery('(max-width:600px)')
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const globalDataSliceState = useSelector(selectGlobalDataState)
    const countries = Array.from(new Set(props.operators.map(op => op.CountryName)))
    const [checked, setChecked] = useState(false)
    const [isRegistered, setIsRegistered] = useState(false)
    const [invoice, setInvoice] = useState('')
    const [emailError, setEmailError] = useState(false)
    const [state, setState] = React.useState({
        name: '',
        lastName: '',
        phone: '',
        email: ''
    })

    const handleTextFieldChange = (prop) => (e) => {
        setState({
            ...state,
            [prop]: e.target.value
        })
    }

    const validateEmail = (email) => {
        const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return regex.test(email);
    };

    const handleClose = () => {
        setIsDialogOpened(false)
    };

    const handleButtonClick = () => {
        if (!validateEmail(state.email)) {
            setEmailError(true); 
        } else {
            dispatch(sendGeneralRequest({ request: { token: globalDataSliceState.token, trxId: props.trxId, email: state.email }, baseUrlKey: 'services', endpoint: 'Esim99/GetSubscribers99Esim' })).then(response => {
                if (response.payload.response.success) {
                    setIsRegistered(response.payload.response.length === 1 ? false : true)
                    dispatch(sendGeneralRequest({ request: { token: globalDataSliceState.token, trxId: props.trxId, isRegistration: response.payload.response.length === 1 ? false : true, packageId: props.package.PackageId, packageName: props.package.DisplayName, packagePrice: props.package.SellPrice, subscriberId: response?.payload?.response?.Subscribers[0]?.SubscriberId, firstName: state.name, lastName: state.lastName, phoneNumber: state.phone, email: state.email }, baseUrlKey: 'services', endpoint: 'Esim99/StartRefill99Esim' })).then(response => {
                        if (response.payload.response.success) {
                            const invoiceData = {
                                'Emri': response.payload.response.trxData[0].FirstName,
                                'Mbiemri': response.payload.response.trxData[0].LastName,
                                'Email': response.payload.response.trxData[0].Email,
                                'Nr. telefonit': response.payload.response.trxData[0].phoneNumber,
                                'ID e paketës': response.payload.response.trxData[0].packageId,
                                'Zona': response.payload.response.trxData[0].packageName,
                                'Vlera në euro': response.payload.response.trxData[0].packagePrice + ' €',
                                'Totali': response.payload.response.trxData[0].packagePriceAll + ' ALL',
                            };
                            setInvoice(invoiceData);
                        }
                    })
                }
            })
        }
    }

    return (
        <>
            {!invoice ? (
                <Box
                    sx={{
                        padding: 3,
                    }}
                >
                    <div style={{ display: 'flex', flexDirection: 'row', marginTop: 5, marginBottom: 25 }}>
                        <Link component={'button'} style={{ marginLeft: -28 }} onClick={() => { navigate(-1) }}><ArrowBackIosNewIcon color='warning' /></Link>
                        <span style={{ marginLeft: 10, color: colors.darkBlue, fontFamily: 'GerberaMedium', fontSize: '1.2rem' }}>{texts['title-package-details']}</span>
                    </div>
                    <Box display="flex" flexDirection={isSmallScreen ? 'column' : 'row'} justifyContent="space-between" mb={2}>
                        <Typography variant="h6" sx={{ fontFamily: 'GerberaBold', color: colors.darkBlue, fontSize: '1.4rem' }}>
                            {props.package.DisplayName}
                        </Typography>
                        {props.state !== '1' && (
                            <div onClick={() => { setIsDialogOpened(true) }} style={{ display: 'flex', textAlign: 'center', background: colors.lightOrange, color: colors.orange, fontFamily: 'GerberaMedium', width: '200px', borderRadius: '8px', padding: '5px 0 5px 15px', cursor: 'pointer' }}>
                                <PublicIcon />
                                <span style={{ fontSize: '0.9rem', margin: '2px 0 0 10px' }}>{texts['prompt-included-countries']}</span>
                            </div>
                        )}
                    </Box>
                    <Box display="flex" flexDirection={'column'} mb={2} xs={12} md={12}>
                        <Box display="flex" alignItems="center" justifyContent="space-between" borderTop={'1px dashed #ddd'} paddingTop={2} xs={12} md={12}>
                            <Typography variant="body2" sx={{ fontFamily: 'GerberaBold', color: colors.darkBlue }}>
                                {texts['prompt-volume']}:
                            </Typography>
                            <Typography variant="body2" sx={{ fontFamily: 'GerberaLight', color: colors.gray }}>
                                {props.package.ConvertedData}
                            </Typography>
                        </Box>
                        <Box display="flex" alignItems="center" justifyContent="space-between" xs={12} md={12} mt={1}>
                            <Typography variant="body2" sx={{ fontFamily: 'GerberaBold', color: colors.darkBlue }}>
                                {texts['prompt-duration']}:
                            </Typography>
                            <Typography variant="body2" sx={{ fontFamily: 'GerberaLight', color: colors.gray }}>
                                {props.package.Validity} {texts['days']}
                            </Typography>
                        </Box>
                    </Box>
                    <Box display="flex" alignItems="center" justifyContent="space-between" borderTop={'1px dashed #ddd'} borderBottom={'1px dashed #ddd'} paddingTop={2} paddingBottom={2} xs={12} md={12}>
                        <Typography variant="h6" sx={{ fontFamily: 'GerberaMedium', color: colors.gray }}>
                            {texts['dialog-gross-amount']}:
                        </Typography>
                        <Typography variant="h6" sx={{ fontFamily: 'GerberaBold', color: colors.orange }}>
                            {props.package.SellPrice} €
                        </Typography>
                    </Box>
                    <Box display="flex" alignItems="center" justifyContent="space-between" mb={2} mt={2}>
                        <Typography variant="body2" sx={{ fontFamily: 'GerberaMedium', color: colors.darkBlue }}>
                            {texts['prompt-esim-compatibility']}
                        </Typography>
                        <FormControlLabel style={{ marginLeft: 20 }} control={<Switch color="warning" checked={checked} onChange={(e) => setChecked(e.target.checked)} />} label="" />
                    </Box>
                    <Grid container spacing={2} mb={3}>
                        <Grid item xs={12} md={6}>
                            <Box display="flex" alignItems="center">
                                <Person sx={{ marginRight: 1 }} color="warning" />
                                <TextField onChange={handleTextFieldChange('name')} value={state.name} fullWidth variant="outlined" color="warning" size="small" label="Emri" />
                            </Box>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Box display="flex" alignItems="center">
                                <Person sx={{ marginRight: 1 }} color="warning" />
                                <TextField onChange={handleTextFieldChange('lastName')} value={state.lastName} fullWidth variant="outlined" color="warning" size="small" label="Mbiemri" />
                            </Box>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Box display="flex" alignItems="center">
                                <Email sx={{ marginRight: 1 }} color="warning" />
                                <TextField onChange={handleTextFieldChange('email')} value={state.email} fullWidth variant="outlined" color="warning" size="small" label="Email" error={emailError} helperText={!emailError ? '' : 'Vendosni një format të skatë emaili'} />
                            </Box>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Box display="flex" alignItems="center">
                                <Phone sx={{ marginRight: 1 }} color="warning" />
                                <TextField onChange={handleTextFieldChange('phone')} value={state.phone} fullWidth variant="outlined" color="warning" size="small" label="Telefon" />
                            </Box>
                        </Grid>
                    </Grid>
                    <Button
                        fullWidth
                        onClick={handleButtonClick}
                        disabled={(!checked || state.name === '' || state.lastName === '' || state.email === '' || state.phone === '')}
                        sx={{
                            background: colors.gradientOrange,
                            color: 'white',
                            fontFamily: 'GerberaBold',
                            borderRadius: 2,
                            padding: '10px 0',
                            textTransform: 'none',
                            marginTop: 5
                        }}
                    >
                        {texts["title-pay"]}
                    </Button>
                    <IncludedCountries isDialogOpened={isDialogOpened} handleClose={handleClose} countries={countries} />
                </Box>
            ) : (
                <SingleExpandedInvoice utilityName={'ESIM_99'} invoice={invoice} globalDataSliceState={globalDataSliceState} transID={props.trxId} isRegistered={isRegistered} />
            )}
        </>
    );
};

export default AddUserData;
